/**
 * Import from node_modules
 */
import 'bootstrap/js/src/scrollspy';
import 'simplebar';

/**
 * Import site scripts
 */
import SkipLinkFocusFix from './site/skip-link-focus-fix';
import Menu from './site/menu';
import Sliders from './site/sliders';
import ScrollTo from './site/scrollTo';
import Styleguide from './site/styleguide';
import Fancybox from './site/fancybox';
import Select2 from './site/select2';
import FormHelpers from './site/formHelpers';
import PerfectScroll from './site/perfectScroll';
import LazyLoading from './site/lazyLoad';
import Register from './site/register';
import TabInfo from './site/tabInfo';
import SingleProduct from './site/singleProduct';
import ProductListing from './site/productListing';
import CustomerUpdate from './site/customerUpdate';
import CompareResize from './site/compareResize';
import SearchFilterAcc from './site/searchFilterAcc';
import SearchFilterDate from './site/searchFilterDate';
import ContactFormScroll from './site/contactFormScroll';
import QuantityInput from './site/quantityInput';
import CheckoutForm from './site/checkoutForm';
import Cart from './site/cart';
import addToCart from './site/addToCart';
import LogosList from './site/logosList';
import CustomerSearch from './site/customerSearch';
import SrcAutosuggest from './site/src-auto-suggest';
import StickyHeader from './site/sticky-header';
import Filters from './site/filters';
import AcfForm from './site/acfForm';
import Newsletter from './site/newsletter';
import EqualHeightsItems from './site/equalHeights';
import ChangeLayout from './site/changelayout';
import loadMore from './site/loadMore';
import AjaxLogin from './site/ajaxLogin';
import Chat from './site/chat';
import Compare from './site/compare';
import SyncOrders from './site/sync-orders';
import PasswordStrength from './site/passwordStrength';
import AddressAutocomplete from './site/AddressAutocomplete';
import MyAccLoader from './site/myAccLoader';
import Invoice from './site/invoice';
import ShowPass from './site/showPass';
import CardKnox from './site/cardnox';

/**
 * Init site scripts
 */
jQuery(function () {
	SkipLinkFocusFix.init();
	Styleguide.init();
	Menu.init();
	Sliders.init();
	ScrollTo.init();
	Fancybox.init();
	Select2.init();
	FormHelpers.init();
	PerfectScroll.init();
	LazyLoading.init();
	TabInfo.init();
	SingleProduct.init();
	ProductListing.init();
	CompareResize.init();
	SearchFilterAcc.init();
	SearchFilterDate.init();
	ContactFormScroll.init();
	// QuantityInput.init();
	CheckoutForm.init();
	Cart.init();
	addToCart.init();
	Register.init();
	LogosList.init();
	CustomerSearch.init();
	SrcAutosuggest.init();
	StickyHeader.init();
	Filters.init();
	AcfForm.init();
	Newsletter.init();
	EqualHeightsItems.init();
	ChangeLayout.init();
	loadMore.init();
	AjaxLogin.init();
	Chat.init();
	CustomerUpdate.init();
	Compare.init();
	PasswordStrength.init();
	AddressAutocomplete.init();
	MyAccLoader.init();
	Invoice.init();
	ShowPass.init();
	// eslint-disable-next-line no-new
	new SyncOrders();
	CardKnox.init();
});
